import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {ConfigService} from '../config/config.service';
import { Location } from '@angular/common';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import {UntypedFormControl, Validators, FormsModule, ReactiveFormsModule, UntypedFormGroup} from '@angular/forms';
import { backendAddress } from '../../environments/environment';
import {LanguageService} from '../service/language.service';
import {filter, switchMap} from 'rxjs/operators';

@Component({
    selector: 'app-painting-page',
    templateUrl: './painting-page.component.html',
    styleUrls: ['./painting-page.component.scss'],
    animations: [
        trigger('fadeAnimation', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(20px)' }),
                animate('500ms ease-in-out', style({ opacity: 1, transform: 'translateY(0)' }))
            ]),
            transition(':leave', [
                animate('500ms ease-in-out', style({ opacity: 0, transform: 'translateY(-20px)' }))
            ])
        ])
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PaintingPageComponent implements OnInit {

  constructor(private router: Router, private api: ConfigService, private location: Location,
              private snackBar: MatSnackBar, private translate: TranslateService,
              // tslint:disable-next-line:variable-name
              private _language: LanguageService ) {
    this._language.current_lang.subscribe(lang => {
      if (lang === 0 ) {
        translate.use('ro');
      } else {
        translate.use('en');
      }
    });
  }

  paintingId = 0;
  paintingCategory = 0;
  isLoaderVisible = false;
  selectedPainting = {
    id: 0,
    path: '',
    name: '',
    category: '',
    tags: '',
    availability: 0,
    price: '',
    dimension: '',
    technique: '',
    description: '',
    // tslint:disable-next-line:variable-name
    created_at: null,
    // tslint:disable-next-line:variable-name
    updated_at: null,
    reservations_count: 0
  };
  typeArt = '';
  artistName = '';
  artistEmail = '';
  artistPhone = '';
  isUserArtist = false;
  lc = true;
  artObject: any;
  isDataReady = false;
  isFirstOpen = true;
  otherDetails = '';
  isDataSent = false;
  errorMessage = '';
  backendAddress = backendAddress.value;
  userId: any;

  myForm = new UntypedFormGroup({
    firstName: new UntypedFormControl('', [Validators.required]),
    lastName: new UntypedFormControl('', [Validators.required]),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    telephone: new UntypedFormControl('', [Validators.required, Validators.pattern(/^\d{10}$/)]),
    termsAndConditions: new UntypedFormControl(false, [Validators.requiredTrue]),
    confidentialityPolicy: new UntypedFormControl(false, [Validators.requiredTrue])
  });
  // tslint:disable-next-line:typedef
  get termsAndConditionsControl() {
    return this.myForm.get('termsAndConditions') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get confidentialityPolicyControl() {
    return this.myForm.get('confidentialityPolicy') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get firstNameFormControl() {
    return this.myForm.get('firstName') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get lastNameFormControl() {
    return this.myForm.get('lastName') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get emailFormControl() {
    return this.myForm.get('email') as UntypedFormControl;
  }
  // tslint:disable-next-line:typedef
  get telephoneFormControl() {
    return this.myForm.get('telephone') as UntypedFormControl;
  }
  toggleDivs(): void {
    this.isFirstOpen = !this.isFirstOpen;
  }
  getPaintingDetails(): void {
    const id = this.router.url.split('/');
    this.typeArt = id[1];
    this.paintingCategory = Number(id[2]);
    this.paintingId = Number(id[3]);
  }

  getPainting(): void {
    this.isLoaderVisible = true;
    this.api.getPaintingById(this.paintingId.toString()).subscribe(
      data => {
        // @ts-ignore
        this.selectedPainting = data.data;
        // @ts-ignore
        this.selectedPainting.technique = data.data.tags;
        this.artistName = 'Andreea Lupu';
        this.artistEmail = 'lupulcreativ@gmail.com';
        this.artistPhone = '+40 740 241 423';
        this.isDataReady = true;
        this.isLoaderVisible = false;
      },
      error => {
        console.log('oopss', error);
        this.translate.get('noPaintingFound').subscribe(message => {
          this.snackBar.open(message, '',
            {duration: 3000, panelClass: 'error-snack-bar',
              horizontalPosition: 'end', verticalPosition: 'top'});
          this.isDataReady = true;
          this.isLoaderVisible = false;
        });
      });
  }

  getArtObject(): void {
    this.isLoaderVisible = true;
    this.api.getArtObjectById(String(this.paintingId)).subscribe(data => {
      this.artObject = data;
      // @ts-ignore
      this.selectedPainting.id = data.id;
        // @ts-ignore
      this.selectedPainting.path = this.backendAddress + data.file_path;
        // @ts-ignore
      this.selectedPainting.name = data.title;
        // @ts-ignore
      this.selectedPainting.category = data.picture_category_id.toString();
        // @ts-ignore
      this.selectedPainting.tags = data.tags;
        // @ts-ignore
      this.selectedPainting.availability = data.availability;
        // @ts-ignore
      this.selectedPainting.price = data.price;
        // @ts-ignore
      this.selectedPainting.dimension = data.dimension;
        // @ts-ignore
      this.selectedPainting.description = data.description;
        // @ts-ignore
      this.selectedPainting.technique = data.technique;
        // @ts-ignore
      this.selectedPainting.created_at = data.created_at;
        // @ts-ignore
      this.selectedPainting.updated_at = data.updated_at;
        // @ts-ignore
      this.artistName = data.user.full_name;
        // @ts-ignore
      this.artistEmail = data.user.email;
        // @ts-ignore
      this.artistPhone = data.user.phone_number;
      this.isLoaderVisible = false;
      this.isDataReady = true;
    },
      error => {
        console.log('error', error);
        this.translate.get('noSelectedArtFound').subscribe(message => {
          this.snackBar.open(message, '',
            {duration: 3000, panelClass: 'error-snack-bar', horizontalPosition: 'end', verticalPosition: 'top'});
          this.isLoaderVisible = false;
          this.isDataReady = true;
        });
      });
  }

  sendEmails(fullName: string): void {
    console.log('art', this.artObject);
    const message = 'Oferta a fost pusa pe: ' + '\"' + this.artObject.title + '\"' +
      '(' + this.artObject.description + ')' + ' de dimensiunea: ' + this.artObject.dimension + ', din anul ' + this.artObject.year;
    this.api.SendMultipleEmails(this.artistEmail, this.emailFormControl.value, fullName, message,
      this.artistName, fullName).subscribe(data => {
    }, err => {
      // tslint:disable-next-line:no-shadowed-variable
      this.translate.get('errorOccurred').subscribe(message => {
        this.snackBar.open(message, '',
          {duration: 3000, panelClass: 'error-snack-bar',
            horizontalPosition: 'end', verticalPosition: 'top'});
      });
    });
  }

  orderFromLCM(fullName: string, phone: string, email: string, offer: string, additionalText: string): void {
    console.log('order from LCM');
    this.isLoaderVisible = true;
    console.log('usserId');
    const postBody = {
      user_id: this.userId, email, name: fullName, phone_number: phone,
      offer, details: additionalText, status: 1, art_object_id: Number(this.paintingId)
    };
    this.api.postOfferCreate(postBody).subscribe((data: any) => {
        this.translate.get('offerSentSuccessfully').subscribe(message => {
          console.log(message);
          // this.message = message; mesaj de succes
          this.sendEmails(fullName);
          this.translate.get('requestSentSuccessfully').subscribe(snackbarMessage => {
            this.snackBar.open(snackbarMessage, '',
              {duration: 3000, panelClass: 'success-snack-bar', horizontalPosition: 'end', verticalPosition: 'top'});
            this.isDataSent = true;
            this.isLoaderVisible = false;
          });
        });
      },
      error => {
        this.translate.get('errorOccurred').subscribe(message => {
          console.log(error);
          this.snackBar.open(message, '',
            {duration: 3000, panelClass: 'error-snack-bar', horizontalPosition: 'end', verticalPosition: 'top'});
          this.isLoaderVisible = false;
        });
      });
  }

  orderFromLC(fullName: string, email: string, message: string): void {
    console.log('send order from LC');
    this.api.SendEmail(fullName, email, message).subscribe(
      data => {
        this.translate.get('requestSentSuccessfully').subscribe(snackbarMessage => {
          this.snackBar.open(snackbarMessage, '',
            {duration: 3000, panelClass: 'success-snack-bar', horizontalPosition: 'end', verticalPosition: 'top'});
          this.isDataSent = true;
          this.isLoaderVisible = false;
        });
      },
      error => {
        // tslint:disable-next-line:no-shadowed-variable
        this.translate.get('errorOccurred').subscribe(snackbarMessage => {
          this.snackBar.open(snackbarMessage, '',
            {duration: 3000, panelClass: 'error-snack-bar', horizontalPosition: 'end', verticalPosition: 'top'});
          this.isDataSent = false;
          this.isLoaderVisible = false;
        });
      });
  }

  sendOrder(): void {
    this.isLoaderVisible = true;

    console.log('sendOrder', this.emailFormControl.value);
    const email = this.emailFormControl.value;
    const fullName = this.firstNameFormControl.value + ' ' + this.lastNameFormControl.value;
    const phone = this.telephoneFormControl.value;
    const additionalText = this.otherDetails;
    const selectedPainingId = this.paintingId;
    const offer = 'no-price';

    // tslint:disable-next-line:max-line-length
    const message = 'Clientul cu email: ' + email + ', avand numele ' + fullName + ' si nr de tel: ' + phone + ' vrea obiectul cu id ul ' + selectedPainingId + '. Additional data details - ' + additionalText + '. ' + 'https://lupulcreativ.ro/#/Painting/5/' + selectedPainingId;

    if (this.lc) {
      console.log('if lc ');
      this.orderFromLC(fullName, email, message);
    } else {
      console.log('else if lc ');
      this.orderFromLCM(fullName, phone, email, offer, additionalText);
    }
  }

  goBack(): void {
    this.location.back();
  }

  checkUser(): void {
    this.api.getLoggedUser().subscribe(user => {
      // @ts-ignore
      if (user){
        // @ts-ignore
        this.userId = user.id;
        // @ts-ignore
        if (user.role_id === 2 || user.role_id === 3){
          this.isUserArtist = true;
        } else {
          this.isUserArtist = false;
          // @ts-ignore
          this.emailFormControl.setValue(user.email);
          // @ts-ignore
          this.firstNameFormControl.setValue(user.first_name);
          // @ts-ignore
          this.lastNameFormControl.setValue(user.last_name);
          // @ts-ignore
          this.telephoneFormControl.setValue(user.phone_number);
        }
      }
    }, error => {
      this.isUserArtist = false;
    });
  }
  ngOnInit(): void {
    this.checkUser();
    this.getPaintingDetails();
    if (this.typeArt === 'Painting') {
      this.lc = true;
      this.getPainting();
    } else {
      this.lc = false;
      this.getArtObject();
    }
  }
}
